import { useEffect } from 'preact/hooks';
import { LivePage, trackLiveEvent } from '../../utils/liveAnalytics';

/** 页面挂载记一次 PV；筛选、分页、主播/日期切换均不额外增加 PV。 */
export function usePageView(page: LivePage): void {
  useEffect(() => {
    const record = (): void => { trackLiveEvent('page_view', { page }); };
    const onPageShow = (event: PageTransitionEvent): void => {
      if (event.persisted) record(); // 从浏览器返回缓存恢复也属于重新进入。
    };
    record();
    window.addEventListener('pageshow', onPageShow);
    return (): void => { window.removeEventListener('pageshow', onPageShow); };
  }, [page]);
}
